import { render } from "./DonationForm.vue?vue&type=template&id=73b0518a&ts=true"
import script from "./DonationForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./DonationForm.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/style-five/DonationForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "73b0518a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('73b0518a', __exports__)) {
    api.reload('73b0518a', __exports__)
  }
  
  module.hot.accept("./DonationForm.vue?vue&type=template&id=73b0518a&ts=true", () => {
    api.rerender('73b0518a', render)
  })

}


export default __exports__